var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("phone-number"),
        state: _vm.getState(_vm.$v.recipient.phone_numbers.number),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.phone_numbers.number),
      },
    },
    [
      _c("EmdInput", {
        attrs: {
          disabled: _vm.disabled,
          mask: ["####-####", "#####-####"],
          name: "phone-number",
        },
        on: { input: () => _vm.$v.recipient.phone_numbers.number.$touch() },
        model: {
          value: _vm.recipient.phone_numbers[0].number,
          callback: function ($$v) {
            _vm.$set(_vm.recipient.phone_numbers[0], "number", $$v)
          },
          expression: "recipient.phone_numbers[0].number",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }